// extracted by mini-css-extract-plugin
export default {"stu_name_td":"style_stu_name_td__sfilH","row_attend_btn":"style_row_attend_btn__WF8LU","row_counsel_btn":"style_row_counsel_btn__B5+Ky"};